<ng-container *ngIf="isLoaded()">
  <formPlyca #formPlycaRef [formConfig]="formConfig" *ngIf="formConfig"></formPlyca>
  <div class="row">
    <div class="col-12">
      <div class="titleElement">Usuarios sugeridos</div>
    </div>
    <div class="col-12">
      <p-table [value]="model.dto.users" dataKey="identifier" [expandedRowKeys]="expandedRows">
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 3rem"></th>
            <th>&nbsp; </th>
            <th></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-user let-expanded="expanded">
          <tr>
            <td>
              <button type="button" pButton pRipple [pRowToggler]="user"
                class="p-button-text p-button-rounded p-button-plain"
                [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
            </td>
            <td>
              <user [user]="user"></user>
            </td>
            <td>{{user.organizationalUnit.name}}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="rowexpansion" let-user>
          <tr>
            <td>&nbsp;</td>
            <td colspan="2">
              <div class="p-p-3">
                <p-table [value]="user.inboxes" dataKey="id">
                  <!-- <ng-template pTemplate="header">
          <tr>
            <- <th pSortableColumn="id">Id <p-sortIcon field="identifier"></p-sortIcon>
            </th>
            <th pSortableColumn="name">Nombre <p-sortIcon field="name"></p-sortIcon>
            </th>
            <th pSortableColumn="description">Descripción <p-sortIcon field="description"></p-sortIcon>
            </th>
            <th style="width: 4rem"></th> ->
            <th colspan="4"></th>
          </tr>
        </ng-template> -->
                  <ng-template pTemplate="body" let-inbox>
          <tr>
            <td style="{{ ((inbox.principal)? 'font-weight:bold' : '') }}">
              <button class="btn btn-default w-100 text-left" (click)="showInbox (inbox)"><i class="fa fa-inbox mr-2"
                  aria-hidden="true"></i>#<span
                  style="{{ ((inbox.principal)? 'font-weight:bold' : '') }}">{{inbox.identifier}}
                  {{inbox.name}}</span></button>
            </td>
            <td> <span *ngIf="inbox?.principal"
                class="badge badge-info text-normal">{{'AssignManager.groupe.data.principalInbox'|translate}}</span>
            </td>
            <td>
              <div class=" float-right d-flex justify-content-end text-right">
                <div class=" btn-group">
                  <button class="btn btn-sm btn-primary t-action-button" aria-expanded="false"
                    title="{{'ControlPanel.inboxs.actions.userTasks' | translate}}" (click)="this.inboxTasks(inbox)">
                    <i class="fas fa-tasks" aria-hidden="true"></i>
                  </button>
                  <button class="btn btn-sm btn-primary t-action-button" aria-expanded="false"
                    title="{{ 'InBox.select'| translate}}">
                    <i class="far fa-1-5x fa-arrow-alt-circle-right" aria-hidden="true"
                      (click)="selectInbox (inbox)"></i>
                  </button>
                </div>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    </td>
    </tr>
    </ng-template>
    </p-table>
  </div>
  </div>
</ng-container>